/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { Switch, Link, Button, CTAs } from '@insticator/insticator-ui'; // iui-material
// utils
import { url } from 'utils/urls';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/management/addons/addoncard/addoncard_styles';



/* ========== ~~~~~~~~~~ ADD-ON CARD ~~~~~~~~~~ ========== */
class AddOnCard extends Component {
    constructor(props){
        super(props);
        this.state = {
            expandableDescription: false,
            descriptionExpanded: false
        };
    }
    handleCreate = () => {
        this.props.createCTA.action()
    };

    renderDescription = description => {
        const charAmount = description !== null ? description.length: 0;
        if(charAmount > 200){
            if(!this.state.expandableDescription) this.setState({ expandableDescription: true });
        }
        return this.props.description
    };

    expandDescriptionLink = () => {
        if(!this.state.expandableDescription) return null;

        return(
            <Link
                type={'action'}
                action={this.handleDescriptionExpand}
                text={this.state.descriptionExpanded ? 'Return' : 'Learn More'}
                icon={this.state.descriptionExpanded ? 'chevron-up' : 'chevron-down'}
                iconRight={true}
            />)
    };

    handleDescriptionExpand = () => this.setState({descriptionExpanded: !this.state.descriptionExpanded});

    renderFooter = () => {
        if (this.props.createMode) return;
        return (
            <div className={'innerfooter'}>
                <div className={'footercontrols'}>
                    <div className={'footernote'}>
                        {this.props.footerNote}
                    </div>
                    <CTAs>
                        {this.props.createCTA && <Button variant={'system'} type={'action'} action={this.handleCreate} text={this.props.createCTA.ctaText} icon={this.props.createCTA.icon}/>}
                        <Button name={'preview'} variant={'primary'} disabled={!this.props.addOnSaved || !this.props.toggle} type={'action'} action={this.props.previewAction} text={'Preview'}/>
                    </CTAs>
                </div>
            </div>
        )
    };
    /* /////////////// RENDER \\\\\\\\\\\\\\\ */
    render() {
        return(
            <div className={`addoncard ${this.props.classes.addoncard}`}>
                <div className={'carddetails'}>
                    <img src={`${url.image}/${this.props.image}`} alt={``} />
                    <div className={'cardinner'}>
                        <div className={'titletoggle'}>
                            <h4>{this.props.title}</h4>
                            <Switch on={!!this.props.toggle} isStatic={true} handleClick={this.props.toggleClick} variant={'secondary'} />
                        </div>
                        <div className={'description'}>
                            <div className={`descriptiontext descriptionexpanded-${this.state.descriptionExpanded} descriptionexpandable-${this.state.expandableDescription}`}>
                                {this.renderDescription(this.props.description)}
                            </div>
                            {this.expandDescriptionLink()}
                        </div>
                        {this.renderFooter()}
                    </div>
                </div>
                <div className={`creationsection open-${!!this.props.createMode}`}>
                    {!!this.props.createMode && this.props.creationElement}
                </div>
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(AddOnCard);
